/* istanbul ignore file */
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useOpportunityId } from 'domain/shared/opportunity';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';

const EditOpportunityButton = (props: EditButtonProps) => {
  const paramId = useOpportunityId();
  const { getUpdateEntityUrl } = useOpportunityUrl();

  return <EditButton path={(id = paramId) => getUpdateEntityUrl(id)} {...props} />;
};

export default EditOpportunityButton;
